export const ApiDef_DB_Expression = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map